export type ChecklistMediaQualityPreset = 'default' | 'high';

export interface ChecklistMediaQualityConfig {
  imageFromCameraDesktop: {
    imageQuality: number;
    ratio: number;
    maxWidth: number;
    maxHeight: number;
  };
  imageFromFileOrMobileCamera: {
    imageQuality: number;
    ratio: number;
    maxWidth: number;
    maxHeight: number;
  };
  selectedVideo: {
    compressionEnabled: boolean;
    maxUploadSizeBytes: number;
    maxWidth: number;
    maxHeight: number;
    frameRate: number;
    webmVideoBitsPerSecond: number;
    mp4VideoBitsPerSecond: number;
    audioBitsPerSecond: number;
  };
  recordedVideo: {
    mobileVideoBitsPerSecond: number;
    desktopVideoBitsPerSecond: number;
    audioBitsPerSecond: number;
  };
}

const MB = 1024 * 1024;

export const DEFAULT_CHECKLIST_MEDIA_QUALITY_PRESET: ChecklistMediaQualityPreset = 'default';

export const CHECKLIST_MEDIA_QUALITY_PRESETS: Record<ChecklistMediaQualityPreset, ChecklistMediaQualityConfig> = {
  default: {
    imageFromCameraDesktop: {
      imageQuality: 75,
      ratio: 75,
      maxWidth: 450,
      maxHeight: 350,
    },
    imageFromFileOrMobileCamera: {
      imageQuality: 80,
      ratio: 75,
      maxWidth: 500,
      maxHeight: 400,
    },
    selectedVideo: {
      compressionEnabled: true,
      maxUploadSizeBytes: 30 * MB,
      maxWidth: 854,
      maxHeight: 480,
      frameRate: 24,
      webmVideoBitsPerSecond: 1200000,
      mp4VideoBitsPerSecond: 1500000,
      audioBitsPerSecond: 128000,
    },
    recordedVideo: {
      mobileVideoBitsPerSecond: 2500000,
      desktopVideoBitsPerSecond: 4000000,
      audioBitsPerSecond: 128000,
    },
  },
  high: {
    imageFromCameraDesktop: {
      imageQuality: 90,
      ratio: 90,
      maxWidth: 1200,
      maxHeight: 900,
    },
    imageFromFileOrMobileCamera: {
      imageQuality: 90,
      ratio: 90,
      maxWidth: 1600,
      maxHeight: 1200,
    },
    selectedVideo: {
      compressionEnabled: false,
      maxUploadSizeBytes: 30 * MB,
      maxWidth: 1280,
      maxHeight: 720,
      frameRate: 24,
      webmVideoBitsPerSecond: 1500000,
      mp4VideoBitsPerSecond: 2000000,
      audioBitsPerSecond: 192000,
    },
    recordedVideo: {
      mobileVideoBitsPerSecond: 5000000,
      desktopVideoBitsPerSecond: 8000000,
      audioBitsPerSecond: 192000,
    },
  },
};

export function resolveChecklistMediaQualityPreset(preset: unknown): ChecklistMediaQualityPreset {
  return preset === 'high' ? 'high' : DEFAULT_CHECKLIST_MEDIA_QUALITY_PRESET;
}

export function resolveChecklistMediaQualityConfig(preset: unknown): ChecklistMediaQualityConfig {
  return CHECKLIST_MEDIA_QUALITY_PRESETS[resolveChecklistMediaQualityPreset(preset)];
}
